import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Box, IconButton, InputAdornment, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import type { FC } from 'react';
import React, { useState } from 'react';

import ScrollContainerWrapper from 'components/DeviceConfigComponents/ScrollContainerWrapper';
import FilledTextField from 'components/MuiCustom/FilledTextField';

interface SetupDevicePasswordProps {
  devicePassword: string;
  setDevicePassword: (value: string) => void;
  handleSubmitDeviceSetup: (event: React.FormEvent<HTMLFormElement>) => void;
}

const SetupDevicePassword: FC<SetupDevicePasswordProps> = props => {
  const { devicePassword, setDevicePassword, handleSubmitDeviceSetup } = props;

  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState<boolean>(false);

  return (
    <ScrollContainerWrapper height="35vh">
      <Box mb={4}>
        <Typography align="center" variant="h2" sx={{ mb: 2 }}>
          {t('common:pages.device_setup.device_password_setup.title')}
        </Typography>
        <Typography align="center" variant="body1">
          {t('common:pages.device_setup.device_password_setup.description')}
        </Typography>
      </Box>
      <Box height="100%" sx={{ overflowY: 'auto' }}>
        <form onSubmit={handleSubmitDeviceSetup}>
          <Box mb={1} mt={2}>
            <FilledTextField
              label={t(
                'common:pages.settings.subpages.password.device_password',
              )}
              name="password"
              type={showPassword ? 'text' : 'password'}
              value={devicePassword}
              onChange={e => setDevicePassword(e.target.value)}
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </form>
        <Typography variant="body2" color="grey.600" pl={1}>
          {t(
            'common:pages.device_setup.device_password_setup.password_validation',
          )}
        </Typography>
      </Box>
    </ScrollContainerWrapper>
  );
};

export default SetupDevicePassword;
